export enum CardProfileType {
    ACTYS_PJE = "ACTYS_PJE",
    AS24_CARD = "AS24_CARD",
    BANK_CARD = "BANK_CARD",
    BONUS_CARD = "BONUS_CARD",
    CODE_ENTRY = "CODE_ENTRY",
    EBT_CARD = "EBT_CARD",
    EPAY_ETOP_UP = "EPAY_ETOP_UP",
    ETOP_UP = "ETOP_UP",
    GIFT_CARD = "GIFT_CARD",
    LOYALTY_CARD = "LOYALTY_CARD",
    PETROL_CARD = "PETROL_CARD",
    PETROL_EMV_CARD = "PETROL_EMV_CARD",
    QR_CODE = "QR_CODE",
    TOP_UP = "TOP_UP",
    PAGOBANCOMAT_CARD = "PAGOBANCOMAT_CARD",
}
